var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.71 249.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #50a8de;\n      }\n\n      .cls-2 {\n        stroke-width: 1.96px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-3, .cls-7, .cls-10 {\n        stroke: #231f20;\n      }\n\n      .cls-2, .cls-4, .cls-8, .cls-11 {\n        fill: #914b2c;\n      }\n\n      .cls-3 {\n        fill: #2e2423;\n        stroke-width: 1.89px;\n      }\n\n      .cls-4, .cls-8, .cls-9 {\n        stroke: #4a1c0d;\n      }\n\n      .cls-4, .cls-9 {\n        stroke-width: 2.38px;\n      }\n\n      .cls-12 {\n        fill: #ee3731;\n      }\n\n      .cls-5, .cls-6 {\n        stroke: #406f8c;\n      }\n\n      .cls-5, .cls-6, .cls-9, .cls-10 {\n        fill: none;\n      }\n\n      .cls-5, .cls-7, .cls-10 {\n        stroke-width: 1.53px;\n      }\n\n      .cls-6 {\n        stroke-width: 1.72px;\n      }\n\n      .cls-7 {\n        fill: #06334f;\n      }\n\n      .cls-8 {\n        stroke-width: 2.55px;\n      }\n\n      .cls-13 {\n        fill: #75381c;\n      }\n\n      .cls-14 {\n        fill: #d7e7f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26.4,144.68c-5.12,9.26-9.17,18.37-14.3,27.63-2.24,4.05-4.64,7.57-5.65,12.09-.81,3.61-1.23,7.81-1.17,11.5.14,8.86,0,18.05-1.14,26.83-.41,3.17-1.01,6.35-.86,9.54.3,6.01,3.46,11.81,8.36,15.32,2.45,1.75,5.88,2.91,8.39,1.25-.73-3.74-4.53-5.96-6.62-9.14-2.49-3.81-2.22-9.21.64-12.75,1.41.6,2.54,1.84,3.02,3.3.37,1.13.36,2.34.57,3.51s.73,2.39,1.78,2.94,2.66.04,2.8-1.14c-.39-4.03-.85-8.24-3.12-11.59-1.12-1.65-2.66-3.06-3.32-4.94-.54-1.52-.44-3.19-.29-4.8.71-7.41,2.5-14.71,5.3-21.61.99-2.45,1.3-4.99,1.85-7.57.59-2.78,2.06-5.18,2.96-7.88.63-1.89,2.66-4.67,3.57-6.45,3.27-6.35,5.54-10.12,9.05-15.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M114.92,139.73c-1.03.81-1.96,1.74-2.76,2.78-4.21,5.52-3.73,13.17-3.07,20.08,1.32,13.66,5.04,43.13,6.36,56.78,0-.14-20.38,8.52-39.47,7.81-10.81-.4-21.92-3.69-32.58-5.53,1.21-18.5,3.58-53.03,4.34-70.05-2.61,2.25-4.97,4.79-7.04,7.54-4.37-5.97-10.72-11.63-18.06-15.21,5.62-6.44,12.12-12.04,18.76-17.42,2.83-2.29,5.71-4.55,8.96-6.18,3.66-1.84,7.7-2.81,11.74-3.51,8.35-1.44,16.89-1.76,25.33-.92,10.4-.17,20.77-1.88,30.67-5.06.82-.26,1.85-.49,2.45.13.21.22.33.5.44.78,2.93,7.42,5.57,14.95,7.91,22.58-3.26.37-6.45,1.27-9.42,2.65-1.61.75-3.16,1.65-4.55,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M75.96,126.48c.36,3.9-.89,7.12-1.64,10.88-.2,1.01-.24,2.08-.17,3.18-.43-4.75-1.05-9.2-1.48-13.93-4.21-.61-7.59-4.11-7.88-8.53l-1.04-15.48c-.33-5.09,3.52-9.5,8.61-9.84.2-.01.4-.02.62-.02,4.82,0,8.89,3.75,9.22,8.64l1.02,15.48c.3,4.64-2.87,8.7-7.28,9.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 116.35,
    cy: 56.92,
    r: 9.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 70.1,
    cy: 53.05,
    rx: 47.84,
    ry: 51.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 20.74,
    cy: 68.68,
    r: 9.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M122.97,81.68c5.47,8.12,12.6,18.5,17.66,26.88-6.59,1.05-12.78,2.54-19.37,3.59,2.32,6.29,4.13,11.47,6.28,18.25.06-.71.13-1.75.24-1.79,3.32-1.24,6.54-1.7,9.95-2.64,8.2-2.24,13.58-4.3,20.37-7.91,1.27-.68,2.42-1.69,3.08-2.98,1.56-3.05-.61-6.61-2.68-9.34-7.3-9.62-14.59-19.23-21.89-28.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M55.36,16.38c-.43-.57-.83-1.17-1.2-1.77.17-.01.35-.02.51-.04.27.58.5,1.19.69,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29.36,31.82c1.08.68,2.07,1.48,2.95,2.38-1.08-.68-2.07-1.48-2.95-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.31,34.2c-1.08-.68-2.07-1.48-2.95-2.38,1.08.68,2.07,1.48,2.95,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29.36,31.82c1.08.68,2.07,1.48,2.95,2.38-1.08-.68-2.07-1.48-2.95-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M55.36,16.38c-.43-.57-.83-1.17-1.2-1.77.17-.01.35-.02.51-.04.27.58.5,1.19.69,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.68,54.98c5.98-3.66,13.34-5.03,20.24-3.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M82.02,51.42c5.07-3.83,11.95-5.15,18.07-3.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M72.1,58.81c.68,1.52.27,3.28.07,4.93-.2,1.65-.05,3.6,1.3,4.58,1.38.99,3.29.47,4.89-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M89.9,79.65c-1.97-1.43-4.88-1.37-6.79.14-.84.66-1.46,1.55-2.08,2.42-.44.62-.88,1.24-1.32,1.86-.31.44-.61,1.11-.2,1.47.37.32.93.06,1.35-.19,1.31-.76,2.78-1.25,4.28-1.45,1.65-.21,3.64-.22,4.5-1.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "91.54 51.42 143.76 57.33 142.97 77.15 90.27 82.15 91.54 51.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.32,144.87c5.69-5.66,15.17-8.25,22.54-10.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.22,68.2c1.89-1.84,3.69-3.97,6.21-4.73,1.43-.43,2.97-.38,4.41-.79,1.81-.52,3.29-1.31,4.69-2.57.33-.3,8.16.12,11.41.51-.45,4.78-.35,7.98-.61,13.16-13.74.83-27.13,1.74-41.09,3.46-.87.11-1.75.04-2.63.08,2.81.32,6.8-1.84,9.23-3.09,3.07-1.58,5.91-3.61,8.38-6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.47,49.53c-4.56,2.79-2.36,10.42,3.18,8.43,4.97-1.99,2.53-11.36-2.99-8.54l-.19.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.35,58.96c-5.87,2.96-9.27-5.89-4.05-8.75,6.46-3.05,10.17,5.24,4.26,8.64l-.21.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.84,54.8c-.2-6.17,7.95-6.67,9.57-1.2,1.78,8.23-8.78,9.84-9.56,1.44v-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.15,80.91c-1.37,2.15-3.68,3.7-6.19,4.15-1.53.29-3.21.14-4.49-.75-1.21-.86-1.86-2.49-.94-3.62.27-.33.94-.9,1.42-1.04,1.18-.34,3.31-1.14,2.93-3-.21-1.03-.57-2.03-.88-3.06-.31-1.06-.78-2.39-.07-3.22.94-1.12,3.01-1.2,4.34-.61,1.79.8,4.07,2.55,4.9,5.72.48,1.83,0,3.82-1.02,5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.12,68.48c1.35-1.25,3.21-1.93,5.05-1.85s3.63.94,4.86,2.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.75,151.59c1.88-1.98,5.09-5.41,7.32-6.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.63,108.56c2.1-.27,3.28-.18,5.3.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.41,40.24c-16.66-.02-30.47-11.91-33.03-27.48-6.02,8.69-16.2,14.4-27.76,14.4-6.94,0-13.38-2.06-18.71-5.56-.61,10.06-6.83,18.66-15.65,22.83,1.84-9.78,6.03-18.62,11.86-25.72,1.08-1.3,2.2-2.54,3.38-3.72C46.2,6.26,57.68.95,70.3.95c4.86,0,9.54.78,13.97,2.26,1.42.46,2.79.98,4.14,1.59,13.93,6.17,24.72,19.23,29.01,35.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71.94,127.02c-2.06,3.44-5.83,10.42-6.9,14.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.04,141.3c-5.61-5.78-8.53-16.17-6.61-24,.89-.21,4.79-.88,5.71-.82.87,2.6.76,5,2.44,7.16.58.74,1.21,1.47,2.03,1.95,1.19.7,2.44,1,3.84,1.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.43,140.1c.04.15-2.49-9.53-4.69-13-.04-.06-.09-.13-.16-.13s-.11.12-.05.14c3,.75,5.3-2.45,7.08-4.98.55-.79.92-1.79,1.11-2.73.32-1.51.08-2.84-.41-4.3,1.66.44,3.73.7,5.44.81,1.58,5.62.99,11.82-1.61,17.05-1.43,2.88-3.52,6.98-6.73,7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M75.4,148.22c-.38-2.34-1.07-5.01-1.24-7.53,0-.05-.01-.11-.01-.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M75.96,126.48c-.01-.12-.02-.25-.04-.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M74.15,140.53s.01.11.01.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M72.68,126.6c-.01-.17-.04-.35-.05-.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.92,126.1c.48,4.06-.84,7.38-1.61,11.26-.67,3.36.53,7.44,1.08,10.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.63,126.07c.44,4.99,1.09,9.63,1.53,14.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M10.99,52.22C-10.77,88.23.78,135.05,36.78,156.81c36,21.76,82.83,10.22,104.6-25.78,21.76-36,10.21-82.83-25.79-104.6C79.59,4.68,32.76,16.22,10.99,52.22ZM41.08,149.7C10.47,131.2-.29,92.37,15.63,60.98l115.83,70.02c-20.39,28.68-59.77,37.2-90.38,18.7ZM136.74,122.27L20.91,52.25c20.38-28.68,59.77-37.2,90.38-18.7,30.61,18.5,41.37,57.34,25.46,88.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodrink);
export default __webpack_public_path__ + "static/media/nodrink.03a63fb86866519d7cff2125ab522531.svg";
export { ForwardRef as ReactComponent };